import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const PmTickets = ({
  fetchPmTicket,
  pmTicket,
  postUpdatePMStatus,
  getPmTicketsFilterDropDown,
  pmTicketFilter,
}) => {
  const headers = [
    'Ticket ID',
    'Created On',
    'PM Schedule Month',
    'Site Number',
    'Assigned To',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await fetchPmTicket(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      if (fetchPmTicket) {
        setIsLoading(true);
        await fetchPmTicket({
          site_no: '',
          client_name: '',
          site_type: '',
          status: [3, 5, 4],
          assignee_ids: '',
        });
        await getPmTicketsFilterDropDown();
        setIsLoading(false);
      }
    })();
  }, [fetchPmTicket]);

  useEffect(() => {
    (async () => {
      if (refresh === true) {
        setIsLoading(true);
        await fetchPmTicket({
          site_no: '',
          client_name: '',
          site_type: '',
          status: [3, 5, 4],
          assignee_ids: '',
        });
        setIsLoading(false);
      }
    })();
  }, [refresh]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    if(filterData === null){
      await fetchPmTicket({
        site_no: '',
          client_name: '',
          site_type: '',
          status: [3, 5, 4],
          assignee_ids: '',
      }, val.selected + 1);
    }else{
      // filterData.status = "4,5,7";
      await fetchPmTicket(filterData, val.selected + 1);
    }
    
    setIsLoading(false);
  };

  useEffect(() => {
    const actions1 = [
      {
        name: 'View Details',
        link: '/dashboard/tickets/view',
        showButtons: false,
      },
      { name: 'Approve', link: '' },
      { name: 'Reject', link: '' },
    ];

    const tableData = [
      'ticket_id',
      'created_on',
      'pmScheduleMonth',
      'site_no',
      'assigned_to',
      'status',
    ];
    if (pmTicket && pmTicket.resultSets) {
      const data = pmTicket.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
              element.status_code === 3
                ? actions1
                : [
                    {
                      name: 'View Details',
                      link: '/dashboard/tickets/view',
                      showButtons: false,
                    },
                  ],
          }
        )
      );

      setListData(data);

      setPageCount(Math.ceil(pmTicket.total / pmTicket.per_page));
    }
  }, [pmTicket, refresh]);

  return (
    <Layout
      title={localization.approvalPmTickets}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        pageCount={pageCount}
        srNo={pmTicket?.from}
        onPageChange={onPageChange}
        detailList={pmTicket && pmTicket.resultSets}
        postUpdatePMStatus={postUpdatePMStatus}
        refreshPage={(val) => {
          if (val === true) {
            setRefresh(true);
          }
        }}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={3}
        listFilterData={pmTicketFilter?.sites ? pmTicketFilter : null}
        pmTicketFilter
      />
    </Layout>
  );
};

export default PmTickets;
